import React from "react";

import {
  makeStyles,
  Theme,
  Tabs,
  Tab,
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  TextField,
  MenuItem,
} from "@material-ui/core";
import { useQueryClient } from "react-query";
import { InTest } from "./inTest/InTest";
import { CharacterizationQueue } from "./characterizationStress/CharacterizationQueue";
import { StressQueue } from "./characterizationStress/StressQueue";

import { useTodoDownload } from "./opsQueuesQueries";
import EndOfLifeQueue from "./EndOfLifeQueue";
import { useLocations } from "../../../intake/intakeQueries";
import { Field } from "formik/dist/Field";
import { toast } from "react-toastify";
import { getTheme } from "../../../common/getLocalTheme";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export const OpsQueuesMainPage = () => {
  const classes = useStyles();
  const queryClient = useQueryClient();
  const [value, setValue] = React.useState(0);
  const [location_id, setLocation] = React.useState(5);
  const [isEnabled, setIsEnabled] = React.useState(false);

  const {
    error: errorLocations,
    data: locations,
    isLoading: isLoadingLocations,
    isError: isErrorLocations,
  } = useLocations();

  const {
    error: errorDownloadedData,
    isError: isErrorDownloadedData,
    isLoading: isLoadingDownloadedData,
  } = useTodoDownload();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  
  const handleChangeLocation = async (event: { target: { value: any; }; }) => {
    const selected_location_id = event.target.value;
    setLocation(selected_location_id);  
  };

  const handleDownload = () => {
    queryClient.refetchQueries(["downloadTodo"]);
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={4}
      >

        <Grid container  justifyContent="flex-end"  style={{ marginRight: 20 }}>
          <TextField
            id="location"
            type="text"
            name="location"
            
            select={true}
            style={{ marginTop: 10 , width: 200}}
            value={location_id}
            disabled={getTheme()}
            onChange={handleChangeLocation}
            variant="outlined"
            label="Location"
            data-testid="location"
          >
            {locations?.map((location: any) => (
              <MenuItem key={location.id} value={location.id}>
                {location.name}
              </MenuItem>
            ))}
          </TextField>
         
        </Grid>
        <Grid item xs={12}>
        <Paper className={classes.root} style={{ marginTop: 20 }}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab label="In Test" />
              <Tab label="Characterization Queue" />
              <Tab label="Stress Queue" />
              <Tab label="EoL Queue" />
            </Tabs>
            <TabPanel value={value} index={0}>
              <InTest location_id = {location_id} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <CharacterizationQueue location_id = {location_id} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <StressQueue location_id = {location_id} />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <EndOfLifeQueue location_id = {location_id}  />
            </TabPanel>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={handleDownload}>
            Todo Download
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
